// This only navigates to the existing signup form. It never submits a form,
// changes consent, identifies a profile, or makes a network request.
export function findExistingNewsletterInput(root = document) {
  const footer = root.getElementById('pogi-newsletter');
  if (!footer) return null;
  return Array.from(footer.querySelectorAll('.pogi-kvform input[type="email"]')).find((input) => {
    if (input.disabled || input.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    if (!input.getClientRects().length) return false;
    const visibility = root.defaultView?.getComputedStyle(input).visibility;
    return visibility !== 'hidden' && visibility !== 'collapse';
  }) || null;
}

export function handleNewsletterNavigation(event, root = document) {
  if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const trigger = event.target?.closest?.('a[data-pogi-newsletter-trigger][href="#pogi-newsletter"]');
  if (!trigger) return;
  const input = findExistingNewsletterInput(root);
  if (!input) return; // Preserve the native footer-anchor fallback.
  event.preventDefault();
  // Native scrolling resolves both Horizon's desktop page-wrapper and the
  // mobile document scroller. An instant move also respects reduced motion.
  input.closest('.pogi-kvform').scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'instant' });
  input.focus({ preventScroll: true });
}

if (typeof document !== 'undefined') document.addEventListener('click', handleNewsletterNavigation);
